<template>
	<div class="userPaymentmobile">
		<b-tabs>
			<b-tab active>
				<template v-slot:title>
					<FileDocumentOutlineIcon />
					<span>{{ $t('userDashboard.paymentHistory.paymentHistory') }}</span>
				</template>
				<template>
					<b-row v-if="userPayments.length">
						<b-col cols="12">
							<h4 class="order-title">{{ $t('receipt number') }}</h4>
						</b-col>
					</b-row>
					<b-row>
						<b-col cols="12" v-if="userPayments.length">
							<span
								v-for="(payment, key) in userPayments"
								:key="key"
								@click="showDialog(payment)"
							>
								<div
									class="box-payment"
									:class="{
										'box-success':
											payment.status == 3 ||
											payment.status == 6 ||
											payment.status == 1 ||
											payment.status == 7,
										'box-danger':
											payment.status == 1 ||
											payment.status == 2 ||
											payment.status == 4
									}"
								>
									<b-row no-gutters>
										<b-col cols="5">
											<p class="order-id">Order{{ payment.id }}</p>
											<p>
												{{
													parseFloat(payment.total_amount).toLocaleString(
														'th-TH'
													)
												}}
												{{ $t('baht') }}
											</p>
										</b-col>
										<b-col cols="7">
											<p class="text-right">
												{{
													payment.created_at
														| formatDate($router.currentRoute.params.lang)
												}}
												{{
													payment.created_at
														| formatHour($router.currentRoute.params.lang)
												}}
											</p>

											<div
												v-if="payment.status == 1"
												class="error text-right order-repeat"
											>
												<RepeatIcon />
												{{ $t('payment.statuses.created') }}
											</div>
											<div
												v-else-if="payment.status == 2"
												class="pending text-right order-repeat"
											>
												<RepeatIcon />
												{{ $t('payment.statuses.processing') }}
											</div>
											<div
												v-else-if="payment.status == 3"
												class="success text-right"
											>
												{{ $t('payment.statuses.completed') }}
											</div>
											<div
												v-else-if="payment.status == 4"
												class="unsuccess text-right order-repeat"
											>
												<RepeatIcon />
												{{ $t('payment.statuses.fail') }}
											</div>
											<div
												v-else-if="payment.status == 6"
												class="success text-right"
											>
												{{ $t('payment.statuses.refund') }}
											</div>
											<div
												v-else-if="payment.status == 7"
												class="success text-right order-repeat"
											>
												<RepeatIcon />
												{{ $t('payment.statuses.awaitingPayment') }}
											</div>
										</b-col>
									</b-row>
								</div>
							</span>
						</b-col>
						<span
							v-if="!userPayments.length"
							style="width: 100%;margin-top: 50px;"
						>
							<b-col style="text-align:center;" cols="12">{{
								$t('You have no payment history')
							}}</b-col>
						</span>
					</b-row>
				</template>
			</b-tab>
			<b-tab>
				<template v-slot:title>
					<HomeOutlineIcon />
					<span>{{
						$t('userDashboard.paymentHistory.changeBillingAddress')
					}}</span>
				</template>
				<template>
					<b-row>
						<b-col cols="12" class="mt-20">
							<b-form id="form-add-address">
								<b-row>
									<InvoiceAddress />
								</b-row>
							</b-form>
						</b-col>
					</b-row>
				</template>
			</b-tab>
		</b-tabs>

		<b-row class="box-order-func" v-bind:class="{ active: isActive }">
			<b-col
				cols="6"
				class="box-func"
				@click="tryPayment()"
				v-if="
					loadingInvoice !== payment.id &&
						(payment.status == 2 ||
							payment.status == 4 ||
							payment.status == 1 ||
							payment.status == 7)
				"
			>
				<span class="func-view">
					<RepeatIcon />
				</span>

				<p>{{ $t('userDashboard.paymentHistory.btnMobile.tryAgain') }}</p>
			</b-col>
			<b-col
				cols="6"
				class="box-func"
				@click="openSendDialog(payment.id)"
				v-if="loadingInvoice !== payment.id && payment.status == 3"
			>
				<span class="func-view">
					<IconSend />
				</span>

				<p>{{ $t('userDashboard.paymentHistory.btnMobile.send') }}</p>
			</b-col>

			<b-col
				cols="6"
				class="box-func"
				@click="downloadInvoice()"
				v-if="
					payment.status == 3 ||
						(payment.status == 7 && payment.payment_method_id == bill_payment)
				"
			>
				<span class="func-send" v-if="loadingInvoice !== payment.id">
					<DownloadIcon />
				</span>
				<p v-if="loadingInvoice !== payment.id">
					{{ $t('userDashboard.paymentHistory.btnMobile.download') }}
				</p>
				<span v-else>
					<b-spinner small label="Loading..." variant="'primary'"></b-spinner>
				</span>
			</b-col>
		</b-row>
		<div
			class="backdrop"
			v-bind:class="{ active: isActive }"
			@click="isActive = false"
		></div>
		<!-- MODAL -->
		<b-modal id="modal-bill-send" centered hide-footer hide-header>
			<b-container fluid>
				<b-form
					class="needs-validation"
					novalidate
					id="form-add-address"
					@submit.prevent="sendInvoice"
				>
					<b-row class="mb-1 text-center" style="margin: 10px;">
						<div @click="hideModal" class="close-modal">
							<CloseIcon />
						</div>
						<div class="title">{{ $t('bill.title') }}</div>

						<div class="wrapper">
							<b-form-group>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.name')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.name')
										"
										class="input-search price-input"
										v-model="sendFirstName"
										id="sendFirstName"
										:class="{ 'is-invalid': $v.sendFirstName.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.frstName')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.surname')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.surname')
										"
										class="input-search price-input"
										v-model="sendLastName"
										id="sendLastName"
										:class="{ 'is-invalid': $v.sendLastName.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.lastName')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.company')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.company')
										"
										class="input-search price-input"
										v-model="sendCompanyName"
										id="sendCompanyName"
										:class="{ 'is-invalid': $v.sendCompanyName.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.company')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{
										$t('userDashboard.paymentHistory.formAddress.tax_id')
									}}</label>
									<b-form-input
										:placeholder="
											$t('userDashboard.paymentHistory.formAddress.tax_id')
										"
										class="input-search price-input"
										v-model="sendTaxId"
										id="sendTaxId"
										:class="{ 'is-invalid': $v.sendTaxId.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.tax')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{ $t('bill.email') }}</label>
									<b-form-input
										:placeholder="$t('bill.email')"
										class="input-search price-input"
										v-model="sendEmail"
										id="sendEmail"
										:class="{ 'is-invalid': $v.sendEmail.$error }"
									></b-form-input>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.email')
									}}</b-form-invalid-feedback>
								</div>
								<div class="form-group">
									<label for>{{ $t('bill.address') }}</label>
									<b-form-textarea
										:placeholder="$t('bill.addressPlaceHolder')"
										class="input-search"
										v-model="sendAddress"
										id="sendAddress"
										:class="{ 'is-invalid': $v.sendAddress.$error }"
									></b-form-textarea>
									<b-form-invalid-feedback>{{
										$t('userDashboard.paymentHistory.error.address')
									}}</b-form-invalid-feedback>
								</div>
							</b-form-group>
						</div>
						<div class="wrap-btn-send">
							<b-button class="cancel" id="cancel" @click="hideModal">{{
								$t('bill.cancel')
							}}</b-button>
							<b-button class="btn-send" id="save" type="submit">{{
								$t('bill.save')
							}}</b-button>
						</div>
					</b-row>
				</b-form>
			</b-container>
		</b-modal>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import * as actionType from '@/controllers/ActionTypes';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import { required, email, integer, minLength } from 'vuelidate/lib/validators';

// Icons
import FileDocumentOutlineIcon from 'vue-material-design-icons/FileDocumentOutline.vue';
import HomeOutlineIcon from 'vue-material-design-icons/HomeOutline.vue';
import RepeatIcon from '@/components/icons/IconRepeatV2';
import IconSend from '@/components/icons/IconSend';
import DownloadIcon from '@/components/icons/IconDownload/index';
import InvoiceAddress from '@/components/invoices/Address';

export default {
	components: {
		FileDocumentOutlineIcon,
		HomeOutlineIcon,
		RepeatIcon,
		IconSend,
		DownloadIcon,
		CloseIcon,
		InvoiceAddress
	},
	props: {
		userPayments: Array,
		bill_payment: Number
	},
	data() {
		return {
			isActive: false,
			showInfoTexInvoiceAddress: false,
			dataForm: [
				{
					company: '',
					taxId: '',
					name: '',
					surname: '',
					address: '',
					zipCode: '',
					province: '',
					state: ''
				}
			],
			payment: {
				id: null,
				status: null
			},
			loading: false,
			loadingInvoice: 0,
			sendAddress: '',
			sendFirstName: '',
			sendLastName: '',
			sendCompanyName: '',
			sendTaxId: '',
			sendEmail: '',
			selectedPaymentId: null
		};
	},
	validations: {
		sendAddress: { required, min: minLength(5) },
		sendEmail: { required, min: minLength(5), email },
		sendFirstName: { required, min: minLength(5) },
		sendLastName: { required, min: minLength(5) },
		sendCompanyName: { min: minLength(5) },
		sendTaxId: { min: minLength(5), integer }
	},
	filters: {
		formatDate(value, lang) {
			if (!value) return;
			let now = moment(new Date());
			let newVal = moment(value);
			// if(now.isSame(newVal, 'day')) return
			return moment(value)
				.local('th')
				.format('DD MMM YYYY');
		},
		formatHour(value, lang) {
			if (!value) return;
			return moment(value)
				.local('th')
				.format('HH:mm');
		}
	},
	methods: {
		...mapActions('PaymentController', [
			actionType.FETCH_USER_PAYMENTS,
			actionType.GENERATE_INVOICE,
			actionType.SEND_INVOICE
		]),
		saveTexInvoiceAddress() {
			this.showInfoTexInvoiceAddress = false;
		},
		modifyTexInvoiceAddress() {
			this.showInfoTexInvoiceAddress = true;
		},
		showDialog(payment) {
			this.payment = payment;
			this.isActive = true;
		},
		downloadInvoice() {
			var vm = this;
			vm.loadingInvoice = this.payment.id;
			this.GENERATE_INVOICE({ id: this.payment.id }).then(function(result) {
				var fileURL = window.URL.createObjectURL(new Blob([result.data]));
				var fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', 'invoice.pdf');
				document.body.appendChild(fileLink);

				fileLink.click();
				vm.loadingInvoice = 0;
			});
		},
		openSendDialog(paymentId) {
			this.selectedPaymentId = paymentId;
			this.$bvModal.show('modal-bill-send');
			this.isActive = false;
		},
		hideModal() {
			this.$bvModal.hide('modal-bill-send');
		},
		sendInvoice() {
			var vm = this;
			this.$v.$touch();

			if (this.$v.$error) {
				return;
			}
			vm.$root.loading = true;
			vm.loadingInvoice = vm.userPaymentId;
			const data = {
				id: vm.selectedPaymentId,
				address: vm.sendAddress,
				email: vm.sendEmail,
				first_name: vm.sendFirstName,
				last_name: vm.sendLastName,
				company_name: vm.sendCompanyName,
				taxid: vm.sendTaxId
			};
			this.SEND_INVOICE(data)
				.then(function(result) {
					vm.loadingInvoice = 0;
					vm.$root.loading = false;
					this.hideModal();
					vm.$bvToast.toast(
						this.$t('userDashboard.paymentHistory.invoiceSentToEmail'),
						{
							title: this.$t('userDashboard.paymentHistory.invoiceSentToEmail'),
							variant: 'success',
							solid: true
						}
					);
				})
				.catch(err => {
					vm.$root.loading = false;
					vm.$bvToast.toast(
						this.$t('userDashboard.paymentHistory.btnMobile.tryAgain'),
						{
							title: this.$t('userDashboard.paymentHistory.btnMobile.tryAgain'),
							variant: 'success',
							solid: true
						}
					);
				});
		},
		tryPayment() {
			this.$router.push({
				name: 'Payment',
				params: {
					id: this.payment.id
				}
			});
		}
	}
};
</script>
<style lang="scss">
@import 'userPaymentMobile.scss';
</style>
